<template>
  <div>
    <p v-if="!videosLoaded">Loading...</p>
    <p v-if="loadingErrorMessage">{{ loadingErrorMessage }}</p>

    <div v-if="videosLoaded">
      <div class="top-container">
        <div>
          <v-layout row="row" wrap="wrap">
            <p class="inline-cream">
              {{ currentVideoIndex }} / {{ videos.length - 1 }}
            </p>
            <v-spacer></v-spacer>
            <v-text-field v-model="goto" label="Go to" placeholder="" rows="1"></v-text-field>
            <v-btn color="primary" flat="flat" @click.native="goToVideo">Go</v-btn>
          </v-layout>
          <DesktopVideoPlayer ref="creamPlayer" :video="videos[currentVideoIndex]" :key="currentVideoIndex"
            :playbackRate="playbackRate" @prevVideo="prev" @nextVideo="next" @prevMatch="prevMatch"
            @nextMatch="nextMatch" @toggleAddToCream="toggleAddToCreamDialog" />
        </div>
        <div v-if="annotatorDisplayed">
          <CreamVideoAnnotator ref="creamAnnotator" :sportID="videos[currentVideoIndex].sportID" />
        </div>
      </div>
      <v-card-actions>
        <v-btn color="primary" flat="flat" @click.native="playbackRate = 0.5">x0.5</v-btn>
        <v-btn color="primary" flat="flat" @click.native="playbackRate = 1">x1</v-btn>
        <v-btn color="primary" flat="flat" @click.native="playbackRate = 1.5">x1.5</v-btn>
        <v-btn color="primary" flat="flat" @click.native="playbackRate = 2">x2</v-btn>
        <v-btn color="primary" flat="flat" @click.native="playbackRate = 3">x3</v-btn>
        <v-btn color="primary" flat="flat" @click.native="prev">PREV</v-btn>
        <v-btn color="primary" flat="flat" @click.native="next">NEXT</v-btn>
        <v-btn color="primary" v-if="sortingMode === 'match'" flat="flat" @click.native="prevMatch">PREV MATCH</v-btn>
        <v-btn color="primary" v-if="sortingMode === 'match'" flat="flat" @click.native="nextMatch">NEXT MATCH</v-btn>
      </v-card-actions>
      <v-spacer></v-spacer>
      <p>
        https://www.rematch.tv/match/{{
          videos[currentVideoIndex].matchID
        }}?videoId={{ videos[currentVideoIndex].id }}
      </p>
      <p><b>Views : </b>{{ videos[currentVideoIndex].hitCounter }}</p>
      <p><b>Likes : </b>{{ videos[currentVideoIndex].likeCounter }}</p>
      <p>
        <b>Date : </b>{{ formatDateDay(videos[currentVideoIndex].date) }} -
        {{ formatDateHour(videos[currentVideoIndex].date) }}
      </p>
      <p>
        <b>Clubs : </b>{{ videos[currentVideoIndex].club1Alias.toUpperCase() }} -
        {{ videos[currentVideoIndex].club2Alias.toUpperCase() }}
      </p>
      <p v-if="
        videos[currentVideoIndex].team1Name &&
        videos[currentVideoIndex].team2Name
      ">
        <b>Teams : </b>{{ videos[currentVideoIndex].team1Name.toUpperCase() }} -
        {{ videos[currentVideoIndex].team2Name.toUpperCase() }}
      </p>
      <p>
        <b>Competition : </b>{{ videos[currentVideoIndex].competitionName }}
      </p>
      <v-btn color="primary" @click.native="toggleAddToCreamDialog">Add to cream</v-btn>
      <v-dialog v-model="addToCreamDialogToggled" :max-width="'800px'">
        <v-card>
          <v-card-title class="headline">Add to cream</v-card-title>

          <!-- Add to cream modal -->
          <v-card-text style="padding-right: 42px;">
            <v-flex>
              <v-text-field v-model="addToCreamItem.clubIndex" style="margin: 12px 0; width: 100%; max-width: 100%;"
                label="Club/team (1 or 2)" placeholder="Club/team (1 or 2)" @input="getClubRegion"></v-text-field>
            </v-flex>
            <v-flex class="two-columns">
              <v-autocomplete v-if="regions.length !== 0" v-model="addToCreamItem.region" label="Region"
                style="margin: 12px 0; width: 100%; max-width: 100%;" :items="regions"
                @input="getRegionDistricts"></v-autocomplete>
              <v-autocomplete v-if="districts.length !== 0" v-model="addToCreamItem.district" label="District"
                style="margin: 12px 0; width: 100%; max-width: 100%;" :items="districts"></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-text-field v-model="addToCreamItem.comment" style="margin: 12px 0; width: 100%; max-width: 100%;"
                label="Comment" placeholder="Comment"></v-text-field>
            </v-flex>
            <v-btn color="primary" @click.native="addToCream">Add to cream</v-btn>
            <p class="error--text" v-if="clubIndexError">
              You must fill "Club/team (1 or 2)"
            </p>
          </v-card-text>
          <!-- End of add to cream modal  -->
        </v-card>
      </v-dialog>

      <CreamModeSelection :selectedVideos="selectedVideos[$country]" @removeVideo="removeVideo"
        @toggleBookmark="toggleBookmark" />
    </div>

    <!-- LOADER -->
    <LoadingPopup :displayed="loaderDisplayed" :title="loaderTitle" :text="loaderText" />
  </div>
</template>

<script>
import DesktopVideoPlayer from './DesktopVideoPlayer'
import CreamVideoAnnotator from './CreamVideoAnnotator.vue'
import CreamModeSelection from './CreamModeSelection'
import LoadingPopup from './common/LoadingPopup'

import { getSportInfos } from '../helpers/get-sport-infos'
import { creamRegions } from '../assets/creamregions'

export default {
  name: 'CreamMode',
  props: ['searchParams', 'sortingMode'],
  components: {
    DesktopVideoPlayer,
    CreamVideoAnnotator,
    CreamModeSelection,
    LoadingPopup
  },
  data () {
    return {
      page: 0,
      pageSize: 300,
      videos: [],
      videosLoaded: false,
      loadingErrorMessage: null,
      currentVideoIndex: 1,
      playbackRate: 1,
      goto: null,
      dateDayOptions: {
        day: 'numeric',
        month: '2-digit',
        year: 'numeric'
      },
      dateHourOptions: {
        hour: '2-digit',
        minute: '2-digit'
      },

      regions: [],
      districts: [],
      addToCreamDialogToggled: false,
      clubIndexError: false,
      addToCreamItem: {
        clubIndex: '',
        region: '',
        district: '',
        comment: ''
      },

      selectedVideos: {
        FR: [
          {
            club: 'Club',
            region: 'RÉGION',
            district: 'Département',
            competition: 'Compétition',
            comment: 'Commentaire',
            video: 'Vidéo',
            bookmarked: 'Bookmarked'
          }
        ],
        US: [
          {
            club: 'Club',
            team: 'Team',
            region: 'State',
            district: 'County',
            competition: 'Competition',
            comment: 'Comment',
            video: 'Video',
            bookmarked: 'Bookmarked'
          }
        ]
      },

      loaderDisplayed: false,
      loaderTitle: null,
      loaderText: null
    }
  },
  mounted () {
    this.loadVideos()
    this.sortRegions()
    this.setKeyboardEvents()
  },
  methods: {
    getClubRegion () {
      if (
        this.addToCreamItem.clubIndex === '1' ||
        this.addToCreamItem.clubIndex === '2'
      ) {
        this.$store
          .dispatch(
            'getClub',
            this.videos[this.currentVideoIndex][`club${this.addToCreamItem.clubIndex}ID`]
          )
          .then(resp => {
            if (resp.regionName) {
              for (const region of creamRegions()) {
                if (region.name === resp.regionName) {
                  this.addToCreamItem.region = region.name
                  this.getRegionDistricts()
                }
                for (const district of region.subRegions) {
                  for (const name of district.names) {
                    if (name === resp.regionName) {
                      this.addToCreamItem.region = region.name
                      this.getRegionDistricts()
                      this.addToCreamItem.district = district.name
                    }
                  }
                }
              }
            }
          })
      } else {
        this.addToCreamItem.region = ''
        this.addToCreamItem.district = ''
      }
    },
    sortRegions () {
      for (const region of creamRegions()) {
        this.regions.push(region.name)
      }
    },
    getRegionDistricts () {
      this.districts = []
      for (const region of creamRegions()) {
        if (region.name === this.addToCreamItem.region) {
          for (const district of region.subRegions) {
            this.districts.push(district.name)
          }
        }
      }
    },
    toggleAddToCreamDialog () {
      this.addToCreamDialogToggled = true
    },
    addToCream () {
      if (
        this.addToCreamItem.clubIndex === '1' ||
        this.addToCreamItem.clubIndex === '2'
      ) {
        if (this.selectedVideos[this.$country].length === 1) {
          window.onbeforeunload = function () {
            return true
          }
        }
        let creamitem = {}
        creamitem.club = this.videos[this.currentVideoIndex][`club${this.addToCreamItem.clubIndex}Alias`].toUpperCase()
        if (this.$country === 'US') {
          creamitem.team = this.videos[this.currentVideoIndex][`team${this.addToCreamItem.clubIndex}Name`].toUpperCase()
        }
        creamitem.region = this.addToCreamItem.region
        creamitem.district = this.addToCreamItem.district
        creamitem.competition = this.videos[this.currentVideoIndex].competitionName
        creamitem.comment = this.addToCreamItem.comment
        creamitem.video = `https://www.rematch.tv/match/${this.videos[this.currentVideoIndex].matchID}?videoId=${this.videos[this.currentVideoIndex].id}`
        creamitem.bookmarked = 0
        this.selectedVideos[this.$country].push(creamitem)
        this.districts = []
        this.addToCreamDialogToggled = false
        this.clubIndexError = false
        this.addToCreamItem = {
          clubIndex: '',
          region: '',
          district: '',
          comment: ''
        }
        this.addToCreamDialogToggled = false
      } else {
        this.clubIndexError = true
      }
    },
    removeVideo (index) {
      this.selectedVideos[this.$country].splice(index, 1)
    },
    toggleBookmark (index) {
      const currentValue = this.selectedVideos[this.$country][index].bookmarked
      this.$set(this.selectedVideos[this.$country][index], 'bookmarked', Number(!currentValue))
    },
    loadVideos () {
      this.displayLoader({
        title: 'Loading videos...',
        text: 'This operation may take some time'
      })
      let params = this.searchParams
      params.page = this.page
      params.pageSize = this.pageSize
      params.freemode = false
      params.sortBy = ['popularity:desc']
      params.withTotalItems = true
      if (this.sortingMode === 'likes') {
        params.getLikes = true
      }
      this.$store
        .dispatch('searchVideos', params)
        .then(resp => {
          for (const vid of resp.items) {
            this.videos.push(vid)
          }
          if (this.videos.length < resp.totalItems) {
            this.page++
            this.loadVideos()
          } else {
            if (this.sortingMode !== 'popularity') {
              this.sortVideos(this.sortingMode)
            } else {
              this.videosLoaded = true
              this.hideLoader()
            }
          }
        })
        .catch(err => {
          this.loadingErrorMessage = `Error loading videos : ${err}`
        })
    },
    sortVideos (sortby) {
      if (sortby === 'match') {
        this.videos.sort((a, b) =>
          a.matchID > b.matchID ? 1 : b.matchID > a.matchID ? -1 : 0
        )
        this.videosLoaded = true
        this.hideLoader()
      } else if (sortby === 'likes') {
        let sorted = this.videos.sort((a, b) => b.likeCounter - a.likeCounter)
        let filtered = []
        for (let i = 0; i <= sorted.length; i++) {
          if (sorted[i].likeCounter !== 0) {
            filtered.push(sorted[i])
          } else {
            this.videos = filtered
            this.videosLoaded = true
            this.hideLoader()
            return
          }
        }
        this.videosLoaded = true
        this.hideLoader()
      } else {
        this.videos.sort((a, b) =>
          a.matchID > b.matchID ? 1 : b.matchID > a.matchID ? -1 : 0
        )
        this.videosLoaded = true
        this.hideLoader()
      }
    },
    prev () {
      if (this.currentVideoIndex > 1) {
        this.annotateVideo(this.videos[this.currentVideoIndex].id)
        this.currentVideoIndex--
      } else {
        alert('no previous video')
      }
    },
    next () {
      if (this.currentVideoIndex < this.videos.length) {
        this.annotateVideo(this.videos[this.currentVideoIndex].id)
        this.currentVideoIndex++
      } else {
        alert('no next video')
      }
    },
    prevMatch () {
      let matchid = this.videos[this.currentVideoIndex].matchID
      let tempindex = 0
      let tempmatchid = null
      for (let i = this.currentVideoIndex; i >= 0; i--) {
        if (this.videos[i].matchID !== matchid) {
          tempindex = i
          tempmatchid = this.videos[i].matchID
          break
        } else {
          if (i === 0) {
            alert('no previous match')
          }
        }
      }
      for (let i = tempindex; i >= 0; i--) {
        if (this.videos[i].matchID !== tempmatchid) {
          this.annotateVideo(this.videos[this.currentVideoIndex].id)
          this.currentVideoIndex = i + 1
          return
        } else {
          if (i === 0) {
            this.annotateVideo(this.videos[this.currentVideoIndex].id)
            this.currentVideoIndex = 1
          }
        }
      }
    },
    nextMatch () {
      let matchid = this.videos[this.currentVideoIndex].matchID
      for (let i = this.currentVideoIndex; i <= this.videos.length - 1; i++) {
        if (this.videos[i].matchID !== matchid) {
          this.annotateVideo(this.videos[this.currentVideoIndex].id)
          this.currentVideoIndex = i
          return
        } else {
          if (i === this.videos.length - 1) {
            alert('no next match')
          }
        }
      }
    },
    goToVideo () {
      if (this.goto > 0 && this.goto <= this.videos.length) {
        this.annotateVideo(this.videos[this.currentVideoIndex].id)
        this.currentVideoIndex = this.goto
      } else {
        alert('illegal value')
      }
    },
    annotateVideo (id) {
      if (this.$refs.creamAnnotator) {
        this.$refs.creamAnnotator.annotate(id)
      }
    },
    formatDateDay (jsDate) {
      let rawDate = new Date(jsDate)
      return rawDate.toLocaleString(
        `${this.$localeRegion}-${this.$country}`,
        this.dateDayOptions
      )
    },
    formatDateHour (jsDate) {
      let rawDate = new Date(jsDate)
      return rawDate.toLocaleString(
        `${this.$localeRegion}-${this.$country}`,
        this.dateHourOptions
      )
    },
    displayLoader (content) {
      this.loaderTitle = content.title || null
      this.loaderText = content.text || null
      this.loaderDisplayed = true
    },
    hideLoader () {
      this.loaderDisplayed = false
      this.loaderTitle = null
      this.loaderText = null
    },
    setKeyboardEvents () {
      document.onkeydown = e => {
        if (
          e.key === ' ' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.playerClicked('space')
        } else if (
          e.key === 'ArrowLeft' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.flashRewind()
        } else if (
          e.key === 'ArrowRight' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.flashForward()
        } else if (
          e.key === 'f' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.fullscreenClicked()
        } else if (
          e.key === 'r' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.slowmoClicked()
        } else if (
          e.key === 'w' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.prevVideo()
        } else if (
          e.key === 'x' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.nextVideo()
        } else if (
          e.key === 'b' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.prevMatch()
        } else if (
          e.key === 'n' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.nextMatch()
        } else if (
          e.key === 'c' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          this.$refs.creamPlayer.toggleAddToCream()
        } else if (
          e.key === 'u' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('u')
          }
        } else if (
          e.key === 'i' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('i')
          }
        } else if (
          e.key === 'o' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('o')
          }
        } else if (
          e.key === 'p' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('p')
          }
        } else if (
          e.key === 'j' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('j')
          }
        } else if (
          e.key === 'k' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('k')
          }
        } else if (
          e.key === 'l' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('l')
          }
        } else if (
          e.key === 'm' &&
          e.target.localName !== 'input' &&
          e.target.localName !== 'textarea'
        ) {
          e.preventDefault()
          if (this.$refs.creamAnnotator) {
            this.$refs.creamAnnotator.select('m')
          }
        }
      }
    }
  },
  computed: {
    annotatorDisplayed () {
      return (
        this.$country === 'FR' &&
        (getSportInfos({ id: this.videos[this.currentVideoIndex].sportID })
          .urlName === 'football' ||
          getSportInfos({ id: this.videos[this.currentVideoIndex].sportID })
            .urlName === 'basketball' ||
          getSportInfos({ id: this.videos[this.currentVideoIndex].sportID })
            .urlName === 'handball')
      )
    }
  },
  beforeDestroy () {
    window.onbeforeunload = null
    document.onkeydown = null
  }
}
</script>

<style lang="scss" scoped>
.v-input {
  margin: 0 12px;
  width: 90px;
  max-width: 90px;
}

.v-input__slot {
  width: 90px;
  max-width: 90px;
}

.top-container {
  display: grid;
  grid-template-columns: 72% 1fr;
  grid-column-gap: 12px;
}

.two-columns {
  display: grid;
  grid-template-columns: 48% 48%;
  grid-column-gap: 4%;
}
</style>



// WEBPACK FOOTER //
// src/components/CreamMode.vue